import { AnimationClipCreator } from 'three/examples/jsm/animation/AnimationClipCreator'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'

class Animation extends AnimationClipCreator {

  static fadeIn ( duration, object ) {

    let tween = new TWEEN.Tween( object.material )
      .to( { opacity: 1 }, duration )
      .delay( 0 )
      .start();

  }

  static fadeOut ( duration, object ) {

    let tween = new TWEEN.Tween( object.material )
      .to( { opacity: 0 }, duration )
      .delay( 0 )
      .start();

  }
}

export { Animation }

